import React, { createContext } from 'react';

export interface ITableContext {
    nameQuery: string;
    prefixStore: string;
}

export const SmxPropsTableContext = createContext<ITableContext>({
    nameQuery: '',
    prefixStore: '',
});

interface IPropsTableProvider extends ITableContext {
    children: React.ReactNode;
}

const PropsTableProvider: React.FC<IPropsTableProvider> = ({ prefixStore, nameQuery, children }) => {
    return <SmxPropsTableContext.Provider value={{ nameQuery, prefixStore }}>{children}</SmxPropsTableContext.Provider>;
};

export default PropsTableProvider;
